import React from "react";

const DICE = `${import.meta.env.BASE_URL}assets/img/dice`;

/**
 * Reference result body for Doli Dana:
 *   .row.row5.worli-result > col-lg-7 (one dice image per card value)
 *   + col-lg-5 .casino-result-desc (rdesc split on "#": Turn, Any Pair, Particular Pair, Sum Total,
 *     Odd/Even, Lucky 7 — or Turn / Win when rdesc has 2 parts or fewer); a row with no value is not listed
 */
const LABELS = ["Turn", "Any Pair", "Particular Pair", "Sum Total", "Odd/Even", "Lucky 7"];

export default function DoliDanaResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const labels = desc.length > 2 ? LABELS : ["Turn", "Win"];
  const rows = labels.map((label, i) => [label, desc[i]]).filter(([, value]) => String(value ?? "").trim() !== "");
  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              {cards.map((c, i) => (
                <div key={i} className="casino-result-cards-item">
                  <img src={`${DICE}/dice${c}.png`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          {rows.map(([label, value], i) => (
            <React.Fragment key={label}>
              {i > 0 && " "}
              <div className="casino-result-desc-item">
                <div>{label}</div> <div>{value}</div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
